import { mergeStyleSets } from "@fluentui/react";

export const styles = mergeStyleSets({
  labelStyles: {
    fontSize: "16px",
    padding: "5px",
    width: "100%",
    borderRadius: "10px",
    backgroundColor: "rgb(255, 255, 255)",
    border: "1px solid rgb(201, 210, 217)",
    borderLeft: "4px solid rgb(0, 120, 212)",
    transition: "background-color 0.2s ease-in-out, border-color 0.2s ease-in-out",
    selectors: {
      ":hover": {
        borderColor: "rgb(0, 120, 212)",
        cursor: "pointer"
      }
    }
  },
  commonLabel: {
    fontSize: "16px",
    cursor: "pointer"
  },
  iconStyle: {
    color: "rgb(0, 120, 212)"
  },
  imageStyle: {
    width: "24px",
    height: "24px",
    margin: "3px 0 0 5px"
  },
  dividerStyle: {
    padding: "0 10px 5px 10px"
  },
  paperStyle: {
    flexShrink: 0,
    marginLeft: "20px",
    marginTop: "10px",
    minHeight: "300",
    padding: "5px",
    width: "28.7%"
  },
  labelStyle: {
    fontSize: 20,
    paddingLeft: 20
  },
  shimmerLoaderItem: {
    display: "flex",
    gap: "8px",
    fontSize: "16px",
    padding: "13px 5px",
    borderRadius: "10px",
    backgroundColor: "rgb(255, 255, 255)",
    border: "1px solid rgb(201, 210, 217)",
    borderLeft: "4px solid rgb(201, 210, 217)",
    transition: "background-color 0.2s ease-in-out, border-color 0.2s ease-in-out"
  },
  shimmerLabelItem: {
    display: "flex",
    gap: "8px",
    marginLeft: "12px",
    marginTop: "10px",
    padding: "5px",
  },
  headerContainer: {
    alignItems: "center"
  }
});